// extracted by mini-css-extract-plugin
module.exports = {"tabs":"styles_tabs__1s2jS","tabs_wrapper":"styles_tabs_wrapper__1cZcB","tab":"styles_tab__2Qxhd","active":"styles_active__1Fiwx"};